/**
 * Custom Scripts for Shopify Theme
 * Optimized for performance
 */

(function() {
  'use strict';
  
  /**
   * Replace 0,00 € with GRATIS text
   */
  function replaceZeroPrices() {
    const prices = document.querySelectorAll('.qsc2-product-item__price');
    
    prices.forEach(el => {
      // Avoid replacing already replaced elements
      if (el.textContent.trim() === '0,00 €' && !el.dataset.replaced) {
        el.innerHTML = '<span style="color: #2ea818; font-weight: bold;">GRATIS</span>';
        el.dataset.replaced = 'true';
      }
    });
  }
  
  /**
   * Initialize on page load
   */
  function init() {
    replaceZeroPrices();
    observeCartDrawer();
  }
  
  /**
   * Observe cart drawer for dynamic changes
   */
  function observeCartDrawer() {
    const cartDrawer = document.querySelector('.qsc2-drawer-body, [data-cart-drawer]');
    
    if (cartDrawer && !cartDrawer.dataset.priceObserved) {
      cartDrawer.dataset.priceObserved = 'true';
      
      const observer = new MutationObserver(() => {
        // Use requestAnimationFrame for better performance
        requestAnimationFrame(replaceZeroPrices);
      });
      
      observer.observe(cartDrawer, { 
        childList: true, 
        subtree: true 
      });
    }
  }
  
  // Execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Listen to Shopify cart events
  document.addEventListener('cart:updated', replaceZeroPrices);
  document.addEventListener('cart:refresh', replaceZeroPrices);
  
})();